"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RichTextRenderer = void 0;
exports.configureSanitization = configureSanitization;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _sanitizeHtml = _interopRequireDefault(require("sanitize-html"));
var sanitizeGlobalOptions = undefined;

/*
 * Set global sanitization configuration options.
 * You can find more about sanitize configuration options here: https://github.com/apostrophecms/sanitize-html
 * */
function configureSanitization(sanitizeOptions) {
  sanitizeGlobalOptions = sanitizeOptions;
}
var renderParagraph = function renderParagraph(block, sanitizeOptions) {
  var props = {
    style: {},
    className: ""
  };
  if (block.data.textAlign) {
    props.style["textAlign"] = block.data.textAlign;
  }
  if (block.data.className) {
    props.className = block.data.className;
  }
  return /*#__PURE__*/_react.default.createElement("p", Object.assign({}, props, {
    className: (0, _classnames.default)("rte-block-paragraph", props.className),
    dangerouslySetInnerHTML: {
      __html: (0, _sanitizeHtml.default)(block.data.text, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, sanitizeGlobalOptions), sanitizeOptions))
    }
  }));
};
var renderDelimiter = function renderDelimiter() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "rte-block-delimiter"
  });
};
var renderHeader = function renderHeader(block, sanitizeOptions) {
  var props = {
    style: {},
    className: ""
  };
  if (block.data.textAlign) {
    props.style["textAlign"] = block.data.textAlign;
  }
  if (block.data.className) {
    props.className = block.data.className;
  }
  switch (block.data.level) {
    case 1:
      return /*#__PURE__*/_react.default.createElement("h1", Object.assign({}, props, {
        className: (0, _classnames.default)(props.className, "rte-block-heading rte-block-heading--h1"),
        dangerouslySetInnerHTML: {
          __html: (0, _sanitizeHtml.default)(block.data.text, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, sanitizeGlobalOptions), sanitizeOptions))
        }
      }));
    case 2:
      return /*#__PURE__*/_react.default.createElement("h2", Object.assign({}, props, {
        className: (0, _classnames.default)(props.className, "rte-block-heading rte-block-heading--h2"),
        dangerouslySetInnerHTML: {
          __html: (0, _sanitizeHtml.default)(block.data.text, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, sanitizeGlobalOptions), sanitizeOptions))
        }
      }));
    case 3:
      return /*#__PURE__*/_react.default.createElement("h3", Object.assign({}, props, {
        className: (0, _classnames.default)(props.className, "rte-block-heading rte-block-heading--h3"),
        dangerouslySetInnerHTML: {
          __html: (0, _sanitizeHtml.default)(block.data.text, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, sanitizeGlobalOptions), sanitizeOptions))
        }
      }));
    case 4:
      return /*#__PURE__*/_react.default.createElement("h4", Object.assign({}, props, {
        className: (0, _classnames.default)(props.className, "rte-block-heading rte-block-heading--h4"),
        dangerouslySetInnerHTML: {
          __html: (0, _sanitizeHtml.default)(block.data.text, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, sanitizeGlobalOptions), sanitizeOptions))
        }
      }));
    case 5:
      return /*#__PURE__*/_react.default.createElement("h5", Object.assign({}, props, {
        className: (0, _classnames.default)(props.className, "rte-block-heading rte-block-heading--h5"),
        dangerouslySetInnerHTML: {
          __html: (0, _sanitizeHtml.default)(block.data.text, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, sanitizeGlobalOptions), sanitizeOptions))
        }
      }));
    case 6:
      return /*#__PURE__*/_react.default.createElement("h6", Object.assign({}, props, {
        className: (0, _classnames.default)(props.className, "rte-block-heading rte-block-heading--h6"),
        dangerouslySetInnerHTML: {
          __html: (0, _sanitizeHtml.default)(block.data.text, (0, _objectSpread2.default)((0, _objectSpread2.default)({}, sanitizeGlobalOptions), sanitizeOptions))
        }
      }));
    default:
      return null;
  }
};
function renderImage(block, sanitizeOptions) {
  return /*#__PURE__*/_react.default.createElement("img", {
    className: "rte-block-image",
    alt: (0, _sanitizeHtml.default)(block.data.caption || "", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, sanitizeGlobalOptions), sanitizeOptions)),
    src: (0, _sanitizeHtml.default)(block.data.file || "", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, sanitizeGlobalOptions), sanitizeOptions))
  });
}
function renderList(block) {
  switch (block.data.style) {
    case "unordered":
      return /*#__PURE__*/_react.default.createElement("ul", {
        className: "rte-block-list"
      }, block.data.items.map(function (text, i) {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: i
        }, text);
      }));
    case "ordered":
      return /*#__PURE__*/_react.default.createElement("ol", {
        className: "rte-block-list"
      }, block.data.items.map(function (text, i) {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: i
        }, text);
      }));
    default:
      return null;
  }
}
function renderQuote(block) {
  return /*#__PURE__*/_react.default.createElement("blockquote", {
    className: "rte-block-blockquote"
  }, /*#__PURE__*/_react.default.createElement("p", null, block.data.text));
}
var defaultRenderers = {
  delimiter: renderDelimiter,
  header: renderHeader,
  image: renderImage,
  list: renderList,
  paragraph: renderParagraph,
  quote: renderQuote
};
var RichTextRenderer = function RichTextRenderer(props) {
  // Combine default renderers with custom renderers
  var renderers = Object.assign({}, defaultRenderers, props.renderers);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, props.data.map(function (block, index) {
    var renderer = renderers[block.type];
    if (!renderer) {
      return null;
    }
    var node = renderer(block, props === null || props === void 0 ? void 0 : props.sanitizationConfig);
    if ( /*#__PURE__*/_react.default.isValidElement(node)) {
      return /*#__PURE__*/_react.default.cloneElement(node, {
        key: index
      });
    }
    return null;
  }));
};
exports.RichTextRenderer = RichTextRenderer;

//# sourceMappingURL=index.js.map